import { CheckboxGroupState } from '@react-stately/checkbox'
import React from 'react'

export const CheckboxContext = React.createContext<CheckboxGroupState | null>(null)
